const contains = function (list, typeInput) {
    return list.findIndex(e => e.value === typeInput) >= 0
}

const getText = function (list,type) {
    const a = list.find(e => e.value === type)

    if(a !== undefined && a !== null){
        return a.text
    }else{
        return ''
    }
}

export default {
    contains,
    getText
}